(function() {
  'use strict';
  
  // Avoid duplicate badges
  if (document.getElementById('dropmagic-badge')) {
    return;
  }
  
  // Initialize PostHog analytics
  !function(t,e){var o,n,p,r;e.__SV||(window.posthog=e,e._i=[],e.init=function(i,s,a){function g(t,e){var o=e.split(".");2==o.length&&(t=t[o[0]],e=o[1]),t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}}(p=t.createElement("script")).type="text/javascript",p.crossOrigin="anonymous",p.async=!0,p.src=s.api_host.replace(".i.posthog.com","-assets.i.posthog.com")+"/static/array.js",(r=t.getElementsByTagName("script")[0]).parentNode.insertBefore(p,r);var u=e;for(void 0!==a?u=e[a]=[]:a="posthog",u.people=u.people||[],u.toString=function(t){var e="posthog";return"posthog"!==a&&(e+="."+a),t||(e+=" (stub)"),e},u.people.toString=function(){return u.toString(1)+".people (stub)"},o="init Ie Ts Ms Ee Es Rs capture Ge calculateEventProperties Os register register_once register_for_session unregister unregister_for_session js getFeatureFlag getFeatureFlagPayload isFeatureEnabled reloadFeatureFlags updateEarlyAccessFeatureEnrollment getEarlyAccessFeatures on onFeatureFlags onSurveysLoaded onSessionId getSurveys getActiveMatchingSurveys renderSurvey canRenderSurvey canRenderSurveyAsync identify setPersonProperties group resetGroups setPersonPropertiesForFlags resetPersonPropertiesForFlags setGroupPropertiesForFlags resetGroupPropertiesForFlags reset get_distinct_id getGroups get_session_id get_session_replay_url alias set_config startSessionRecording stopSessionRecording sessionRecordingStarted captureException loadToolbar get_property getSessionProperty Ds Fs createPersonProfile Ls Ps opt_in_capturing opt_out_capturing has_opted_in_capturing has_opted_out_capturing clear_opt_in_out_capturing Cs debug I As getPageViewId captureTraceFeedback captureTraceMetric".split(" "),n=0;n<o.length;n++)g(u,o[n]);e._i.push([i,s,a])},e.__SV=1)}(document,window.posthog||[]);
  posthog.init('phc_KwMZEhmFKWQtPbGLaZ9dRn8glyQXeyVSuBQIjnevskz', {
    api_host: 'https://us.i.posthog.com',
    defaults: '2025-05-24',
    person_profiles: 'always', // or 'always' to create profiles for anonymous users as well
  });
  
  // Whitelist domains
  const allowedReferrers = [
    'minea.com',
    'autods.com',
    'dropship.io',
    'winninghunter.com',
    'trendtrack.io',
    'dropispy.com',
    'bigspy.com',
    'ppspy.com',
    'pipiads.com',
    'nichescraper.com',
    'findniche.com',
    'sellthetrend.com'
  ];
  
  // Cache configuration
  const CACHE_KEY = 'dropmagic_badge_validation';
  const CACHE_DURATION = 1000 * 60 * 60; // 1 hour in milliseconds
  

  // Store referrer in sessionStorage on first visit
  function persistReferrer() {
    try {
      if (!sessionStorage.getItem('dropmagic_original_referrer') && document.referrer) {
        sessionStorage.setItem('dropmagic_original_referrer', document.referrer);
      }
    } catch (e) {
      // sessionStorage not available
    }
  }
  
  // Check if referrer is from Facebook Ads Library
  // Logic: facebook.com referrer + no fbclid parameter = Ads Library
  function isFromFacebookAdsLibrary(referrerUrl) {
    try {
      const referrerParsed = new URL(referrerUrl);
      
      // Check if referrer is from Facebook
      const isFacebookReferrer = referrerParsed.hostname.includes('facebook.com');
      
      if (!isFacebookReferrer) {
        return false;
      }
      
      // Check current URL for fbclid parameter
      const currentUrl = new URLSearchParams(window.location.search);
      const hasFbclid = currentUrl.has('fbclid');
      
      // If from Facebook but no fbclid, it's likely Ads Library
      const isAdsLibrary = !hasFbclid;
      
      if (isAdsLibrary) {
        console.log('✅ Detected Facebook Ads Library traffic (facebook.com referrer + no fbclid)');
      }
      
      return isAdsLibrary;
      
    } catch (e) {
      return false;
    }
  }
  
  // Check if referrer matches whitelist (general domains)
  function matchesGeneralReferrer(referrerUrl) {
    try {
      const url = new URL(referrerUrl);
      const matchedDomain = allowedReferrers.find(domain => url.hostname.endsWith(domain));
      return matchedDomain || false;
    } catch (e) {
      return false;
    }
  }
  
  // Main referrer validation
  function matchesReferrer() {
    // Persist referrer for future checks
    persistReferrer();
    
    // Get the best available referrer source
    let referrerUrl = null;
    
    // Priority order: document.referrer -> sessionStorage -> performance API
    if (document.referrer) {
      referrerUrl = document.referrer;
    } else {
      try {
        const persistedReferrer = sessionStorage.getItem('dropmagic_original_referrer');
        if (persistedReferrer) {
          referrerUrl = persistedReferrer;
        } else {
          const navEntries = performance.getEntriesByType('navigation');
          if (navEntries.length > 0 && navEntries[0].referrer) {
            referrerUrl = navEntries[0].referrer;
          }
        }
      } catch (e) {
        // Fallback methods not available
      }
    }
    
    if (!referrerUrl) {
      console.log('🔍 Dropmagic: No referrer found');
      return false;
    }
    
    console.log('🔍 Dropmagic: Referrer found:', referrerUrl);
    
    // Determine referrer type
    let referrerType = null;
    let additionalData = {};
    
    if (isFromFacebookAdsLibrary(referrerUrl)) {
      referrerType = 'facebook_ads_library';
    } else {
      const matchedDomain = matchesGeneralReferrer(referrerUrl);
      if (matchedDomain) {
        referrerType = matchedDomain;
        try {
          additionalData.referrer_domain = new URL(referrerUrl).hostname;
        } catch (e) {
          // URL parsing failed
        }
      }
    }
    
    // If no valid referrer type found, exit
    if (!referrerType) {
      console.log('❌ Dropmagic: Referrer not whitelisted:', referrerUrl);
      return false;
    }
    
    console.log('✅ Dropmagic: Valid referrer type:', referrerType);
    
    return {
      isValid: true,
      referrerUrl,
      referrerType
    };
  }
  
  // Get cached validation result
  function getCachedValidation() {
    try {
      const cached = localStorage.getItem(CACHE_KEY);
      if (!cached) return null;
      
      const { timestamp, isValid, shopDomain } = JSON.parse(cached);
      const now = Date.now();
      
      // Check if cache is expired or for different shop
      const currentShop = window.Shopify?.shop;
      if (now - timestamp > CACHE_DURATION || shopDomain !== currentShop) {
        localStorage.removeItem(CACHE_KEY);
        return null;
      }
      
      return isValid;
    } catch (e) {
      localStorage.removeItem(CACHE_KEY);
      return null;
    }
  }
  
  // Cache validation result
  function setCachedValidation(isValid) {
    try {
      const cacheData = {
        timestamp: Date.now(),
        isValid: isValid,
        shopDomain: window.Shopify?.shop
      };
      localStorage.setItem(CACHE_KEY, JSON.stringify(cacheData));
    } catch (e) {
      console.warn('Failed to cache badge validation');
    }
  }
  
  // Check API validation
  async function checkApiValidation() {
    // Check cache first
    const cachedResult = getCachedValidation();
    if (cachedResult !== null) {
      console.log('💾 Dropmagic: Using cached subscription status:', cachedResult ? 'Active' : 'Inactive');
      return cachedResult;
    }
    
    // Get Shopify shop domain
    const shopifyDomain = window.Shopify?.shop;
    if (!shopifyDomain) {
      console.warn('Shopify shop domain not found');
      return false;
    }
    
    console.log('🔍 Dropmagic: Checking subscription for shop:', shopifyDomain);
    
    try {
      const response = await fetch(`https://app.dropmagic.ai/api/is-allowed?shopify_domain=${encodeURIComponent(shopifyDomain)}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });
      
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }
      
      const data = await response.json();
      const isValid = data.isValid === true;
      
      console.log('🔒 Dropmagic: Subscription status:', isValid ? 'Active ✅' : 'Inactive ❌');
      
      // Cache the result
      setCachedValidation(isValid);
      
      return isValid;
    } catch (error) {
      console.warn('❌ Dropmagic: Failed to check subscription:', error);
      console.log('🔒 Dropmagic: Subscription status: Unknown (API Error) ⚠️');
      // On error, cache false result for shorter duration
      setCachedValidation(false);
      return false;
    }
  }
  
  // Main validation function
  async function shouldShowBadge() {
    console.log('🚀 Dropmagic: Starting badge validation...');
    
    // Check referrer first
    const referrerResult = matchesReferrer();
    if (referrerResult) {
      console.log('🎉 Dropmagic: Badge will SHOW - Valid referrer found, skipping API check');
      return {
        shouldShow: true,
        referrerUrl: referrerResult.referrerUrl,
        referrerType: referrerResult.referrerType
      };
    }
    
    console.log('🔍 Dropmagic: No valid referrer found, checking API...');
    
    // No valid referrer, check API - show badge if subscription is INACTIVE
    const hasValidSubscription = await checkApiValidation();
    
    if (!hasValidSubscription) {
      console.log('🎉 Dropmagic: Badge will SHOW - No subscription found');
      return {
        shouldShow: true,
        referrerUrl: null,
        referrerType: null
      };
    } else {
      console.log('🛑 Dropmagic: Badge will NOT show - Active subscription found');
      return false;
    }
  }
  
  // Wait for DOM to be fully loaded and create badge
  async function initBadge() {
    // Check if badge should be shown
    const badgeValidation = await shouldShowBadge();
    if (!badgeValidation || !badgeValidation.shouldShow) {
      return;
    }
    
    const { referrerUrl, referrerType } = badgeValidation;
    
    // Create the badge container
    const badge = document.createElement('div');
    badge.id = 'dropmagic-badge';
    
    // Create the inner content container
    const innerContainer = document.createElement('div');
    innerContainer.className = 'dropmagic-inner';
    
    // Create the logo container
    const logoContainer = document.createElement('div');
    logoContainer.className = 'dropmagic-logo';
    
    // Dropmagic logo
    const logo = document.createElement('img');
    logo.src = 'https://safe.dropmagic.ai/storage/v1/object/public/assets/dropmagic/logo_square.png';
    logo.alt = 'Dropmagic';
    logo.className = 'dropmagic-logo-img';
    logoContainer.appendChild(logo);
    
    // Create the text container
    const textContainer = document.createElement('div');
    textContainer.className = 'dropmagic-text';
    
    const madeWithText = document.createElement('div');
    madeWithText.className = 'dropmagic-made-with';
    madeWithText.textContent = 'Made with';
    
    const dropmagicLogo = document.createElement('img');
    dropmagicLogo.className = 'dropmagic-brand';
    dropmagicLogo.src = 'https://safe.dropmagic.ai/storage/v1/object/public/assets/dropmagic/name_logo.png';
    dropmagicLogo.alt = 'Dropmagic';
    dropmagicLogo.width = 85;
    dropmagicLogo.height = 18;
    
    textContainer.appendChild(madeWithText);
    textContainer.appendChild(dropmagicLogo);
    
    // Create notification tooltip
    const notification = document.createElement('div');
    notification.className = 'dropmagic-notification';
    
    // Determine notification message
    let notificationMessage = '';
    if (referrerType) {
      let referrerName = 'a dropshipping platforms';
      
      if (referrerType === 'facebook_ads_library') {
        referrerName = 'Facebook Ads Library';
      } else if (referrerUrl) {
        try {
          referrerName = new URL(referrerUrl).hostname;
        } catch (e) {
          referrerName = 'a referrer';
        }
      }
      
      notificationMessage = `You are seeing this because we detected you are coming from ${referrerName}. This will not be shown to an end customer.`;
    } else if (window.Shopify && window.Shopify.designMode === true) {
      notificationMessage = 'Your Dropmagic subscription is not active, this is why you are seeing this badge.';
    }
    
    if (notificationMessage) {
      notification.textContent = notificationMessage;
    }
    
    // Assemble the badge
    innerContainer.appendChild(logoContainer);
    innerContainer.appendChild(textContainer);
    badge.appendChild(innerContainer);
    
    if (notificationMessage) {
      badge.appendChild(notification);
    }
    
    // Add styles with animations
    const styles = document.createElement('style');
    styles.textContent = `
      @keyframes dropmagicSlideInBounce {
        0% {
          transform: translateY(100px);
          opacity: 0;
        }
        60% {
          transform: translateY(-7px);
          opacity: 1;
        }
        80% {
          transform: translateY(2px);
        }
        100% {
          transform: translateY(0);
          opacity: 1;
        }
      }
      
      @keyframes dropmagicFadeIn {
        0% {
          opacity: 0;
        }
        100% {
          opacity: 1;
        }
      }
      
      #dropmagic-badge {
        position: fixed;
        bottom: 20px;
        right: 20px;
        background: #000000;
        border-radius: 12px;
        padding: 4px;
        z-index: 999;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
        cursor: pointer;
        opacity: 0;
        transform: translateY(100px);
        transition: all 0.3s cubic-bezier(0.4, 0.0, 0.2, 1);
      }
      
      #dropmagic-badge.animate-in {
        animation: dropmagicSlideInBounce 0.5s cubic-bezier(0.4, 0.0, 0.2, 1) forwards;
      }
      
      #dropmagic-badge:hover {
        transform: translateY(-4px) scale(1.02);
        box-shadow: 0 12px 35px rgba(0, 0, 0, 0.4);
        transition: all 0.3s cubic-bezier(0.4, 0.0, 0.2, 1);
      }
      
      #dropmagic-badge:active {
        transform: translateY(-2px) scale(1.01);
        transition: all 0.1s cubic-bezier(0.4, 0.0, 0.2, 1);
      }
      
      .dropmagic-inner {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 8px 12px;
        border: 1px solid rgba(255, 255, 255, 0.2);
        border-radius: 8px;
        transition: border-color 0.3s ease;
      }
      
      #dropmagic-badge:hover .dropmagic-inner {
        border-color: rgba(255, 255, 255, 0.3);
      }
      
      .dropmagic-logo {
        display: flex;
        align-items: center;
        flex-shrink: 0;
      }
      
      .dropmagic-logo-img {
        width: 30px;
        height: 30px;
        display: block;
        transition: transform 0.3s ease;
      }
      
      .dropmagic-text {
        display: flex;
        flex-direction: column;
        gap: 1px;
      }
      
      .dropmagic-made-with {
        font-size: 10px;
        color: rgba(255, 255, 255, 0.7);
        line-height: 1.2;
        font-weight: 600;
        transition: color 0.3s ease;
      }
      
      .dropmagic-brand {
        display: block;
        transition: opacity 0.3s ease;
      }
      
      #dropmagic-badge:hover .dropmagic-made-with {
        color: rgba(255, 255, 255, 0.9);
      }
      
      #dropmagic-badge:hover .dropmagic-brand {
        opacity: 1;
      }
      
      .dropmagic-notification {
        position: absolute;
        bottom: 100%;
        right: 0;
        margin-bottom: 12px;
        background: #1a1a1a;
        color: #ffffff;
        padding: 12px 16px;
        border-radius: 8px;
        font-size: 13px;
        line-height: 1.4;
        white-space: nowrap;
        max-width: 300px;
        white-space: normal;
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
        opacity: 0;
        visibility: hidden;
        transform: translateY(8px);
        transition: all 0.3s cubic-bezier(0.4, 0.0, 0.2, 1);
        pointer-events: none;
        z-index: 10000;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
        font-weight: 500;
        border: 1px solid rgba(255, 255, 255, 0.1);
      }
      
      .dropmagic-notification::after {
        content: '';
        position: absolute;
        top: 100%;
        right: 20px;
        border: 6px solid transparent;
        border-top-color: #1a1a1a;
      }
      
      #dropmagic-badge:hover .dropmagic-notification {
        opacity: 1;
        visibility: visible;
        transform: translateY(0);
      }
      
      /* Mobile responsiveness */
      @media (max-width: 768px) {
        #dropmagic-badge {
          bottom: 15px;
          right: 15px;
          transform: scale(0.9) translateY(100px);
        }
        
        #dropmagic-badge.animate-in {
          animation: dropmagicSlideInBounce 0.5s cubic-bezier(0.4, 0.0, 0.2, 1) forwards;
        }
        
        #dropmagic-badge:hover {
          transform: scale(0.92) translateY(-2px);
        }
        
        .dropmagic-notification {
          max-width: 250px;
          font-size: 12px;
          padding: 10px 12px;
        }
        
        .dropmagic-notification::after {
          right: 16px;
          border-width: 5px;
        }
      }
    `;
    
    // Add click handler with link
    badge.addEventListener('click', function(e) {
      e.preventDefault();
      
      // Track badge click event with PostHog
      try {
        if (window.posthog && typeof window.posthog.capture === 'function') {
          const eventData = {
            shop_domain: window.Shopify?.shop
          };
          
          // Only add referrer data if it exists
          if (referrerUrl && referrerType) {
            eventData.property = referrerUrl;
            eventData.referrer_type = referrerType;
          }
          
          posthog.capture('shopify_saas_badge_clicked', eventData);
        }
      } catch (e) {
        console.warn('PostHog badge click tracking failed:', e);
      }
      
      window.open('https://dropmagic.ai?utm_source=badge', '_blank', 'noopener,noreferrer');
    });
    
    // Insert styles and badge into the page
    document.head.appendChild(styles);
    document.body.appendChild(badge);
    
    // Trigger the slide-in animation after 1.5 seconds
    setTimeout(function() {
      badge.classList.add('animate-in');
      
      // Track badge display event with PostHog
      try {
        if (window.posthog && typeof window.posthog.capture === 'function') {
          const eventData = {
            shop_domain: window.Shopify?.shop,
            type: 'subscription_inactive'
          };
          
          // Only add referrer data if it exists
          if (referrerType) {
            eventData.property = referrerUrl;
            eventData.referrer_type = referrerType;
            eventData.type = 'referrer';
          }

          posthog.capture('shopify_saas_badge_displayed', eventData);
        }
      } catch (e) {
        console.warn('PostHog badge display tracking failed:', e);
      }
    }, 1500);
  }
  
  // Check if DOM is already loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBadge);
  } else {
    // DOM is already loaded
    initBadge();
  }
  
})(); 